"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Presets = void 0;
const mobx_1 = require("mobx");
const PRESET_KET = "__presets";
class Presets {
    constructor() {
        this.list = ["Fortunes"];
        this.current = "Fortunes";
    }
    setCurrent(name) {
        this.current = name;
        this.save();
    }
    save() {
        localStorage.setItem(PRESET_KET, JSON.stringify(this));
    }
    load() {
        try {
            const val = JSON.parse(localStorage.getItem(PRESET_KET));
            for (const k of Object.keys(val)) {
                this[k] = val[k];
            }
        }
        catch (e) {
        }
    }
    add(name) {
        this.list.push(name);
        this.save();
    }
    remove(name) {
        this.list = this.list.filter(p => p !== name);
        this.save();
    }
    getUniqName(prefix) {
        let suffix = this.list.length;
        while (true) {
            const name = `${prefix} ${suffix}`;
            if (!this.list.some(p => p === name)) {
                return name;
            }
        }
    }
}
__decorate([
    mobx_1.observable
], Presets.prototype, "list", void 0);
__decorate([
    mobx_1.observable
], Presets.prototype, "current", void 0);
__decorate([
    mobx_1.action.bound
], Presets.prototype, "setCurrent", null);
__decorate([
    mobx_1.action.bound
], Presets.prototype, "save", null);
__decorate([
    mobx_1.action.bound
], Presets.prototype, "load", null);
__decorate([
    mobx_1.action.bound
], Presets.prototype, "add", null);
__decorate([
    mobx_1.action.bound
], Presets.prototype, "remove", null);
exports.Presets = Presets;
exports.default = new Presets();
